import React, { useEffect, useState } from 'react';
import {
  Box,
  TextField,
  Typography,
  Button,
  Grid,
  Paper
} from '@mui/material';
import axios from 'axios';

const IDConfirmationForm = ({ extractedData, onSubmit }) => {
  const [formData, setFormData] = useState({
    first_name: '',
    middle_name: '',
    last_name: '',
    address: '',
    state_in_address: '',
    expiration_date: '',
    document_number: '',
    date_of_birth:null
  });

  // Prefill form when extractedData changes
  useEffect(() => {
    if (extractedData) {
      setFormData({
        first_name: extractedData.first_name || '',
        middle_name: extractedData.middle_name || '',
        last_name: extractedData.last_name || '',
        address: extractedData.address || '',
        state_in_address: extractedData.state_in_address || '',
        expiration_date: extractedData.expiration_date || '',
        document_number: extractedData.document_number || '',
        date_of_birth: extractedData.date_of_birth || '',
      });
    }
  }, [extractedData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    try {
      const response = await axios.post('/api/store-id-data', formData);
      alert('Information saved!');
      if (onSubmit) onSubmit();
    } catch (err) {
      console.error(err);
      alert('Failed to save data.');
    }
  };

  return (
    <Paper sx={{ p: 4, maxWidth: 600, mx: 'auto', mt: 4 }}>
      <Typography variant="h6" gutterBottom>
        Confirm and Edit ID Information
      </Typography>
      <Grid container spacing={2}>
        {[
          ['First Name', 'first_name'],
          ['Middle Name', 'middle_name'],
          ['Last Name', 'last_name'],
          ['Address', 'address'],
          ['state_in_address', 'state_in_address'],
          ['Expiry Date', 'expiration_date'],
          ['Document Number', 'document_number'],
          ['Age', 'date_of_birth']
        ].map(([label, field]) => (
          <Grid item xs={12} sm={field === 'address' ? 12 : 6} key={field}>
            <TextField
              fullWidth
              label={label}
              name={field}
              value={formData[field]}
              onChange={handleChange}
            />
          </Grid>
        ))}
      </Grid>
      <Button
        sx={{ mt: 3 }}
        variant="contained"
        color="primary"
        onClick={handleSubmit}
      >
        Submit
      </Button>
    </Paper>
  );
};

export default IDConfirmationForm;
